import { RouterLink } from '@gc-bridge/components/RouterLink';
import { ChooseRegionDialog } from '@gc-bridge/components/Section/ChooseRegionDialog';
import { LinkLabel } from '@gc-bridge/components/Section/LinkLabel';
import { useConfigStore } from '@gc-bridge/stores/config';
import { AdditionalColors } from '@gc-bridge/theme/colors';
import { DisplayedRemoteApplication } from '@gcportal/base';
import { Link } from '@mui/material';
import { isString } from 'lodash';
import { useCallback, useState } from 'react';

const linkStyles = {
  '&:not(:last-child)': {
    paddingBottom: '8px',
    borderBottom: `2px solid ${AdditionalColors.InterstellarBlue}`,
  },
};

export interface Props {
  remote: DisplayedRemoteApplication;
}

export function Remote({ remote }: Props) {
  const [openChooseRegionDialog, setOpenChooseRegionDialog] = useState(false);
  const regions = useConfigStore((state) => state.config?.regions);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (!remote.active) {
        event.preventDefault();
      }
    },
    [remote.active]
  );

  if (isString(remote.url)) {
    return (
      <Link
        color="primary"
        component={RouterLink}
        to={remote.url}
        target={remote.shouldRedirect ? '_blank' : undefined}
        sx={{ textDecoration: 'none', ...linkStyles }}
        onClick={handleClick}
      >
        <LinkLabel label={remote.name} disabled={!remote.active} />
      </Link>
    );
  }

  return (
    <>
      <Link
        component="button"
        onClick={() => {
          setOpenChooseRegionDialog(true);
        }}
        sx={{ textDecoration: 'none', ...linkStyles }}
      >
        <LinkLabel label={remote.name} disabled={!remote.active} />
      </Link>
      {openChooseRegionDialog ? (
        <ChooseRegionDialog
          regionUrls={remote.url}
          regionNames={regions}
          onClose={() => setOpenChooseRegionDialog(false)}
          shouldRedirect={remote.shouldRedirect}
        />
      ) : undefined}
    </>
  );
}
